import { useEffect, useMemo, useState } from "react";
import { estadoDasSalas, type ConsultaDaSala } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";
import { useFeature } from "@/lib/use-feature";

export type SalaAgora = { id: string; nome: string; cor: string | null; ordem: number };

const hhmm = (d: Date) => `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;

/** O relógio da tela: "HH:MM", andando a cada 30s. */
export function useRelogio() {
  const [agora, setAgora] = useState(() => hhmm(new Date()));
  useEffect(() => {
    const t = setInterval(() => setAgora(hhmm(new Date())), 30_000);
    return () => clearInterval(t);
  }, []);
  return agora;
}

/** Salas de hoje e o estado de cada uma agora. Sem tempo real: busca de novo a cada 30s e ao voltar pra aba. */
export function useSalasAgora({ recepcao = false }: { recepcao?: boolean } = {}) {
  const temRecurso = useFeature("salas");
  const consulta = trpc.salas.agora.useQuery({ recepcao }, { enabled: temRecurso, refetchInterval: 30_000, refetchOnWindowFocus: true });
  const agora = useRelogio();
  const dados = consulta.data;
  return useMemo(() => {
    const salas = (dados?.salas ?? []) as SalaAgora[];
    const consultas = (dados?.consultas ?? []) as ConsultaDaSala[];
    return { temRecurso, carregando: temRecurso && consulta.isLoading, salas, consultas, agora, ...estadoDasSalas(salas, consultas, agora) };
  }, [dados, agora, temRecurso, consulta.isLoading]);
}
